<quill-view
  [content]="value() | resolvePlaceholders: replacements()"
  [sanitize]="false"
  [format]="'html'"
></quill-view>